import { usePermissionStore } from '@/stores/permission'

interface PermissionGuardProps {
	permission?: string
	children: React.ReactNode
	fallback?: React.ReactNode
}

export function PermissionGuard({ permission, children, fallback = null }: PermissionGuardProps) {
	const { hasPermission } = usePermissionStore()

	if (!hasPermission(permission)) {
		return <>{fallback}</>
	}

	return <>{children}</>
}
